
// Menu items for consistency
const userMenuItems = (role) => {
    return [

        ...(
            (!role || role === 'user') ?
                [
                    { name: "Join as Trainer", path: "/trainer/create", isLink: true },
                    { name: "Join as Gym Facility", path: "/gym/create", isLink: true },
                    { name: "Join as Training Provider", path: "/training-provider/create", isLink: true },

                ] : [
                    { name: "My Profile", path: "/my-profile", isLink: true },
                ]
        ),
        { name: "Logout", path: "/logout", isLink: false },
    ]
};

const _getWhatsAppMsg = ({ contact_no = "", msg = "" }) => {

    const message = `https://wa.me/91${contact_no || "0000000000"}?text=${encodeURIComponent(msg)}`
    return message;

}

export { userMenuItems, _getWhatsAppMsg };